<template>
    <div>
        <select-dropdown
            :auto-translate="false"
            :input-label="$t('settings.locations.location')"
            :options="availableLocations"
            v-model="form.company_location_id"
        />
        <simple-input
            :disabled="!!form.company_location_id"
            @input="form.postal_code = $event"
            :input-label="$t('jobs.postal_code')"
            :value="!!form.company_location_id ? getAddressOfLocation.postal_code : form.postal_code"
        />
        <simple-input
            :disabled="!!form.company_location_id"
            @input="form.city = $event"
            :input-label="$t('jobs.city')"
            :value="!!form.company_location_id ? getAddressOfLocation.city : form.city"
        />
        <select-dropdown
            :autoTranslate="false"
            @change="form.country = $event"
            :disabled="!!form.company_location_id"
            :input-label="$t('applications.country')"
            :options="getCountriesSelect"
            :value="!!form.company_location_id ? getAddressOfLocation.country_code : form.country"
            searchable
        />
        <select-dropdown
            :auto-translate="false"
            :input-label="$t('jobs.labels.place_of_work')"
            :options="placeOfWorkOptions"
            v-model="form.remote"
        />
    </div>
</template>

<script>
import SelectDropdown from "./forms/SelectDropdown";
import Input from "./forms/Input";
import * as jobs from "../services/JobService";
import {getCountriesSelectOptions} from "../../shared/helpers";
import Form from "../etc/forms/Form";
import Loading from "./ui/Loading";
import SimpleButton from "./ui/SimpleButton";
import Checkbox from "./forms/Checkbox";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";
import {useJobsStore} from "../state/modules/jobs";

export default {
    components: {
        Checkbox,
        SimpleButton,
        Loading,
        'simple-input': Input,
        SelectDropdown
    },
    props: {
        fetchFilters: {
            type: Boolean,
            default: true,
        },
        value: Form,
    },
    computed: {
        ...mapStores(useMainStore, useJobsStore),
        locale() {
            return this.mainStore.locale;
        },
        availableParameters() {
            return this.jobsModuleStore.availableParameters;
        },
        getCountriesSelect() {
            return getCountriesSelectOptions(this.$i18n);
        },
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        availableLocations() {
            let locations = this.availableSomething('locations', this.availableParameters, this.$t('general.other'));

            locations = locations.map(location => {
                if (!location.label && this.availableParameters.locations) {
                    location.label = this.availableParameters.locations.find(i => i.value === location.value).address;
                }
                return location;
            });

            return locations;
        },
        getAddressOfLocation() {
            if (!this.form.company_location_id)
                return {};

            if (!this.availableParameters.locations)
                return {};

            const location = this.availableParameters.locations.find(i => i.value === parseInt(this.form.company_location_id));

            if (!location)
                return {};

            return location;
        },
        placeOfWorkOptions() {
            let options = this.availableSomething('place_of_work', this.availableParameters);
            return typeof options !== 'undefined' ? options.slice(1) : [];
        },
    },
    methods: {
        availableSomething(something, source, defaultText = null) {

            if (!defaultText)
                defaultText = this.$t('general.select_subject', {subject: this.$t('jobs.labels.' + something)});

            let defaultOption = {
                value: null,
                label: '--- ' + defaultText + ' ---'
            };

            if (typeof source[something] === 'undefined') {
                return [defaultOption];
            }

            let options = source[something].map(value => ({
                value: value.value, label: value.translations[this.locale] || ''
            }));

            return [defaultOption, ...options];
        }
    }
}
</script>
